<template>
  <div class="cloneScreen">
    <div class="form">
      <div class="grid">
        <div class="grid__column--twelve">
          <ul class="scrollBox__header">
              <li class="scrollBox__type">Select screens where you want to clone</li>
            </ul>
            <ul class="scrollBox__list">
              <li class="scrollBox__item" v-for="sliderList in sliders" :key="sliderList.id" v-if="sliderList.id != slider.id">
                <label class="scrollBox__label">
                  <input type="checkbox" class="scrollBox__checkbox" :value="sliderList.id" v-model="clone_to"> {{ sliderList.title }}
                </label>
              </li>
            </ul>

            <button type="button" @click="cloneSlider" class="btn btn--primary">Clone slider</button>
            <button type="button" @click="selectAll" class="btn btn--success">Select all</button>
            <button type="button" @click="deselectAll" class="btn btn--success">Deselect all</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Slider from '@/model/Slider'

export default {
  props: ['slider', 'slides'],
  data () {
    return {
      clone_to: [],
      sliders: []
    }
  },
  mounted () {
    Slider.index({allPages: true, screen_ip: true}).then((response) => {
      this.sliders = response.data.data
    })
  },
  methods: {
    cloneSlider () {
      axios.post(`/sliders/${this.$route.params.id}/clone`, { clone_to: this.clone_to }).then((response) => {
        this.$snotify.success('Successfully cloned.')
        this.clone_to = []
      })
    },
    selectAll () {
      this.sliders.map(sliderList => {
        if (sliderList.id !== this.slider.id) {
          this.clone_to.push(sliderList.id)
        }
      })
    },
    deselectAll () {
      this.clone_to = []
    }
  }
}
</script>

<style lang="stylus">
.cloneScreen
    border-bottom 1px solid #eee
</style>



// WEBPACK FOOTER //
// src/components/Screen/CloneScreen.vue